import { SignIn, SignUp } from "@clerk/react";
import { ShieldCheck, Vault } from "lucide-react";
import { ZeroFeeBadge } from "../components/StatusBadge";

export default function AuthPage({ mode }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2" data-testid={`${mode}-page`}>
      <div className="relative hidden flex-col justify-between overflow-hidden border-r border-slate-800/70 p-12 lg:flex">
        <div className="grid-bg absolute inset-0 opacity-40" />
        <div className="relative flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-emerald-500 text-[#04110c]"><Vault size={18} /></div>
          <span className="font-heading text-lg font-bold">CofrePay Gateway</span>
        </div>
        <div className="relative max-w-md space-y-6">
          <ZeroFeeBadge />
          <h1 className="font-heading text-5xl font-extrabold leading-tight tracking-tight">Seu cofre de recebimentos e pagamentos.</h1>
          <p className="text-slate-400">Acesso exclusivo do administrador, protegido por Google Authenticator em cada etapa.</p>
        </div>
        <div className="relative flex items-center gap-2 text-xs text-slate-500"><ShieldCheck size={14} className="text-emerald-400" /> Tentativas de acesso são registradas com IP.</div>
      </div>
      <div className="flex items-center justify-center p-6">
        {mode === "sign-in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
